import { useCallback } from 'react';
import { useSignIn } from '@clerk/nextjs';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

import { prepareFirstFactor } from '../factors';
import type { SignInStrategy } from '../type';

type Props = Readonly<{
  /** Current verification strategy */
  strategy: SignInStrategy;
  onSubmit: (strategy: SignInStrategy) => void;
}>;

export const ChooseStrategy = ({ strategy, onSubmit }: Props) => {
  const { signIn } = useSignIn();

  const handleChange = useCallback(
    async (value: SignInStrategy) => {
      try {
        await prepareFirstFactor({ strategy: value, signIn });
        onSubmit(value);
      } catch (error) {
        console.error(JSON.stringify(error, null, 2));
      }
    },
    [onSubmit, signIn],
  );

  return (
    <Card className="w-full min-w-96">
      <CardHeader>
        <CardTitle>Use another method</CardTitle>
        <CardDescription>Facing issues? You can use any of these methods to sign in.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-y-4">
        {strategy !== 'email_code' && (
          <Button type="button" variant="link" onClick={() => handleChange('email_code')}>
            Email code
          </Button>
        )}
        {strategy !== 'password' && (
          <Button type="button" variant="link" onClick={() => handleChange('password')}>
            Password
          </Button>
        )}
      </CardContent>
      <CardFooter>
        <div className="grid w-full gap-y-4">
          <Button onClick={() => onSubmit(strategy)}>Go back</Button>
        </div>
      </CardFooter>
    </Card>
  );
};
